import { render, staticRenderFns } from "./RouteTag.vue?vue&type=template&id=b2852144&"
import script from "./RouteTag.vue?vue&type=script&lang=js&"
export * from "./RouteTag.vue?vue&type=script&lang=js&"
import style0 from "./RouteTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports